import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const bannerHeight = 150;

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    // No padding on mobile, add padding on larger screens
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },
  topBar: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: bannerHeight,
    backgroundImage: 'url(/images/banner.jpeg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // reduce banner height on small screens
    [theme.breakpoints.down('xs')]: {
      height: 90,
      backgroundPosition: 'top',
    },
  },
  content: {
    margin: 'auto',
    width: '100%',
  },
}));

const ProfileContainer = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {/* <div className={classes.topBar} /> */}
      <div className={classes.content}>{children}</div>
    </div>
  );
};
ProfileContainer.propTypes = {
  children: PropTypes.any
};
export default ProfileContainer